import React from 'react'

export default props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 17.86 14.78"
        {...props}
    >
        <defs>
            <clipPath id="clip-path" transform="translate(-994.27 -493.5)">
                <path
                    fill="none"
                    d="M995.8 495.82H1010.04V504.2H995.8z"
                    transform="rotate(11.62 1003.29 500.237)"
                ></path>
            </clipPath>
            <clipPath id="clip-path-2" transform="translate(-994.27 -493.5)">
                <path
                    fill="none"
                    d="M996.65 498.77H1011.27V507.37H996.65z"
                ></path>
            </clipPath>
        </defs>
        <path
            fill="#b8b8b8"
            d="M995.8 495.82H1010.04V504.2H995.8z"
            transform="rotate(11.62 2931.153 -4632.235)"
        ></path>
        <rect
            width="12.23"
            height="6.53"
            x="996.81"
            y="496.75"
            fill="#666"
            rx="1.39"
            transform="rotate(11.62 2931.153 -4632.235)"
        ></rect>
        <ellipse
            cx="1002.85"
            cy="499.96"
            fill="#4d4d4d"
            rx="2.26"
            ry="1.68"
            transform="rotate(-78.38 202.992 862.992)"
        ></ellipse>
        <circle cx="12.11" cy="7.19" r="0.92" fill="#4d4d4d"></circle>
        <circle cx="4.88" cy="5.7" r="0.92" fill="#4d4d4d"></circle>
        <g fill="#4d4d4d" clipPath="url(#clip-path)">
            <circle cx="16.36" cy="3.96" r="0.92"></circle>
            <circle cx="2.45" cy="0.92" r="0.92"></circle>
            <circle cx="0.92" cy="9.16" r="0.92"></circle>
            <circle cx="14.71" cy="12" r="0.92"></circle>
        </g>
        <path fill="#bebebe" d="M2.38 5.28H17V13.879999999999999H2.38z"></path>
        <rect
            width="12.55"
            height="6.71"
            x="3.41"
            y="6.22"
            fill="#949494"
            rx="1.18"
        ></rect>
        <ellipse
            cx="9.6"
            cy="9.53"
            fill="#4d4d4d"
            rx="1.72"
            ry="2.32"
        ></ellipse>
        <circle cx="13.3" cy="9.53" r="0.95" fill="#4d4d4d"></circle>
        <circle cx="5.73" cy="9.53" r="0.95" fill="#4d4d4d"></circle>
        <g fill="#929292" clipPath="url(#clip-path-2)">
            <circle cx="16.91" cy="5.41" r="0.95"></circle>
            <circle cx="2.29" cy="5.23" r="0.95"></circle>
            <circle cx="2.47" cy="13.83" r="0.95"></circle>
            <circle cx="16.91" cy="13.83" r="0.95"></circle>
        </g>
    </svg>
)
